import * as moment from 'moment';
import {
    ITranslateProvider,
    ITranslateService,
    ITranslationTable
} from 'angular-translate';

const localeEn = require<ITranslationTable>('./locale-en.json');
const localeRu = require<ITranslationTable>('./locale-ru.json');

export function translateSources($translateProvider: ITranslateProvider) {
  $translateProvider
      .translations('en', localeEn)
      .translations('ru', localeRu)
      .preferredLanguage('en').fallbackLanguage('en')
      .useSanitizeValueStrategy('escapeParameters')
      .useLocalStorage()
      .useMessageFormatInterpolation();
}
translateSources.$inject = ['$translateProvider'];

/**
 * Ensure that the moment locale is always up to date with the language
 * in angular-translate.
 * @param $rootScope Event bus to listen to changes in the language.
 * @param $translate The initial language selection is retrieved from this.
 * @param $log Logging of debug information..
 */
export function adjustMomentLocale($rootScope: ng.IRootScopeService,
                                   $translate: ITranslateService,
                                   $log: ng.ILogService) {
  $rootScope.$on('$translateChangeStart',
      ($event: ng.IAngularEvent, args: {language: string}) => {
        // I guess that the following line doesn't work because of:
        //https://github.com/moment/moment/issues/1797
        moment.locale(args.language);
        $log.debug(`Language changing to ${args.language}
                    from ${$translate.proposedLanguage()}.`);
      });
  moment.locale($translate.proposedLanguage());
}
adjustMomentLocale.$inject = ['$rootScope', '$translate', '$log'];



/** WEBPACK FOOTER **
 ** ./app/locales.ts
 **/